var _circle, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.08
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 268.59,
    r: 243.41
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.6621,
    y1: 576.4395,
    x2: -12.6621,
    y2: 636.4395,
    gradientTransform: "matrix(8.3934 0 0 -8.3934 362.2788 5341.9175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    cx: 256,
    cy: 251.803,
    r: 251.803
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.04
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.6621,
    y1: 576.4395,
    x2: -12.6621,
    y2: 636.4395,
    gradientTransform: "matrix(8.3934 0 0 -8.3934 362.2788 5341.9175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M256,0C116.929,0,4.197,112.732,4.197,251.803S116.929,503.607,256,503.607 s251.803-112.732,251.803-251.803S395.071,0,256,0z M256,486.82c-129.586,0-235.016-105.43-235.016-235.016 S126.414,16.787,256,16.787s235.016,105.43,235.016,235.016S385.586,486.82,256,486.82z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.16
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,0C116.929,0,4.197,112.732,4.197,251.803S116.929,503.607,256,503.607s251.803-112.732,251.803-251.803 S395.071,0,256,0z M256,495.213c-134.429,0-243.41-108.98-243.41-243.41S121.571,8.393,256,8.393s243.41,108.98,243.41,243.41 S390.429,495.213,256,495.213z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.6621,
    y1: 579.4395,
    x2: -12.6621,
    y2: 633.4395,
    gradientTransform: "matrix(8.3934 0 0 -8.3934 362.2788 5341.9175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3871E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61C5F6"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    cx: 256,
    cy: 251.803,
    r: 226.623
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.16
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.6621,
    y1: 579.4395,
    x2: -12.6621,
    y2: 633.4395,
    gradientTransform: "matrix(8.3934 0 0 -8.3934 362.2788 5341.9175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M256,25.18c-125.163,0-226.623,101.46-226.623,226.623S130.837,478.426,256,478.426 s226.623-101.46,226.623-226.623S381.163,25.18,256,25.18z M256,470.033c-120.521,0-218.229-97.708-218.229-218.23 S135.479,33.574,256,33.574s218.23,97.708,218.23,218.229S376.521,470.033,256,470.033z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.6621,
    y1: 593.4395,
    x2: -12.6621,
    y2: 623.4382,
    gradientTransform: "matrix(8.3934 0 0 -8.3934 362.2788 5341.9175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EFF6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M301.912,302.164H192.378h-39.365h-22.914c-9.233,0-16.787-7.554-16.787-16.787 c0-9.233,7.554-16.787,16.787-16.787h43.562l62.615-101.729l-19.725-32.147c-4.868-7.89-2.434-18.214,5.456-23.082 c7.89-4.868,18.214-2.434,23.082,5.456L256,134.799l10.911-17.71c4.868-7.89,15.192-10.324,23.082-5.456 c7.89,4.868,10.324,15.192,5.456,23.082l-19.725,32.147L256,198.841l-42.974,69.749h69.498 C293.351,276.144,300.737,288.231,301.912,302.164z M381.902,268.59H338.34l-8.142-13.178l-47.255-76.884 c-8.813,8.393-14.353,20.228-14.353,33.406c0,3.022,0.252,5.875,0.839,8.729l17.123,27.782l12.422,20.144l20.648,33.574 l31.224,50.78c3.106,5.12,8.645,7.974,14.269,7.974c3.022,0,6.043-0.839,8.813-2.518c7.89-4.868,10.324-15.192,5.456-23.082 l-20.396-33.154h22.914c9.233,0,16.787-7.554,16.787-16.787C398.689,276.144,391.134,268.59,381.902,268.59z M146.717,312.404 l-14.101,22.914c-4.868,7.89-2.434,18.214,5.456,23.082c2.77,1.679,5.791,2.518,8.813,2.518c5.624,0,11.163-2.854,14.269-7.974 l21.991-35.756c-6.883-4.281-15.024-6.631-23.67-6.631C155.027,310.557,150.746,311.145,146.717,312.404z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.27aa79762b1ea20777b7a05c3ae9e69f.svg";
export { ForwardRef as ReactComponent };